/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefTryItRequestData } from '../../models/api-def-try-it-request-data';

export interface TryItGetRequestHistory$Params {

/**
 * The URL of the request to filter by.
 */
  url?: string;

/**
 * The path of the endpoint to filter by.
 */
  endpointPath?: string;

/**
 * The HTTP method to filter requests by.
 */
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' | 'HEAD' | 'OPTIONS';

/**
 * The HTTP status code to filter requests by.
 */
  statusCode?: number;

/**
 * The ID of the user to filter requests by.
 */
  userId?: string;

/**
 * The ID of the organization to check the access rights.
 */
  organizationId?: string;

/**
 * The ID of the project to filter requests by.
 */
  projectId?: string;

/**
 * Maximum number of requests to return (default 20)
 */
  limit?: number;

/**
 * Start date to filter requests by (inclusive).
 */
  startAfter?: string;

/**
 * End date to filter requests by (exclusive).
 */
  endBefore?: string;

/**
 * Field to order the results by (default is requestSentAt).
 */
  orderBy?: 'requestSentAt';

/**
 * Order direction (default is descending).
 */
  order?: 'asc' | 'desc';
}

export function tryItGetRequestHistory(http: HttpClient, rootUrl: string, params?: TryItGetRequestHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'requests'?: Array<ApiDefTryItRequestData>;
}>> {
  const rb = new RequestBuilder(rootUrl, tryItGetRequestHistory.PATH, 'get');
  if (params) {
    rb.query('url', params.url, {});
    rb.query('endpointPath', params.endpointPath, {});
    rb.query('method', params.method, {});
    rb.query('statusCode', params.statusCode, {});
    rb.query('userId', params.userId, {});
    rb.query('organizationId', params.organizationId, {});
    rb.query('projectId', params.projectId, {});
    rb.query('limit', params.limit, {});
    rb.query('startAfter', params.startAfter, {});
    rb.query('endBefore', params.endBefore, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('order', params.order, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'requests'?: Array<ApiDefTryItRequestData>;
      }>;
    })
  );
}

tryItGetRequestHistory.PATH = '/tryIt';
